
import { DeduplicateTraficSource } from '@gate31/feature/DeduplicateTraficSource/DeduplicateTraficSource';

export class DeduplicateTraficSourceDesk extends DeduplicateTraficSource {}
